import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isFloat } from 'validator';
import numeral from 'numeral';
import { List, Map } from 'immutable';
import moment from 'moment';

// Componentes
import Select from "../../components/common/virtualized-select";
import DateInput from "../common/date-input";
import {projectTasks} from "../../components/common/project-tasks"

// Actions
import {getEmployees, cleanEmployees} from "../../actions/employees";

import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class EditWorkReportDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            employee: this.props.workReport.employee_id,
            date: moment(this.props.workReport.date),
            hours: this.props.workReport.hours,
            task: this.props.workReport.task,
            cost_per_hour: this.props.workReport.cost
        };
    };

    componentDidMount() {
        this.props.onRef(this);
        this.props.getEmployees({
            filters: { status: 'active' },
            projection: 'employee_code name cost_per_hour'
        });
    }

    validate = () => {
        this.props.onCanSubmit(this.state.employee !== -1 && this.state.date.isValid() && this.state.task !== -1 && this.state.hours > 0);
    };

    onAddButtonClick = () => {
        // update work report
        this.props.updateWorkReport(this.props.workReport._id, {
            employee: this.state.employee,
            project: this.props.project.get('_id'),
            date: this.state.date,
            hours: this.state.hours,
            task: this.state.task,
            cost: this.state.cost_per_hour * this.state.hours
        });
        // close modal
        this.props.onCloseModal();
    }

    render() {

        return (
            <div>
                <div className="row modal-row">
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Proyecto</label>
                        <input
                            className="form-control"
                            type="text"
                            value={`[${this.props.project.get('project_code')}] ${this.props.project.get('name')}`}
                            disabled={true}
                        />
                    </div>
                    <div className="col-4">
                        <div className="form-group">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Fecha</label>
                            <DateInput
                                onChange={(selectedValue) => this.setState({
                                    date: selectedValue
                                }, this.validate)}
                                value={this.state.date}
                                inputWrapperStyle={{height: 40}}
                                inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                iconStyle={{top: 9, right: 12}}
                            />
                        </div>
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Empleado</label>
                        <Select
                            className="virtualized-select"
                            options={this.props.employees.toJS()}
                            value={this.state.employee}
                            labelKey="select"
                            valueKey="_id"
                            matchProp="select"
                            multi={false}
                            searchable={true}
                            clearable={false}
                            onChange={(employee) => {
                                if (employee) {
                                    this.setState({
                                        employee: employee._id,
                                        cost_per_hour: employee.cost_per_hour
                                    }, this.validate);
                                }
                            }}
                        />
                    </div>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Tarea</label>
                        <Select
                            className="virtualized-select"
                            options={projectTasks.toJS()}
                            value={this.state.task}
                            labelKey="name"
                            valueKey="task_code"
                            matchProp="name"
                            multi={false}
                            searchable={true}
                            clearable={false}
                            onChange={(task) => {
                                if (task) {
                                    this.setState({ task: task.task_code }, this.validate);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="row modal-row" style={{ paddingTop: 10 }}>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Coste por hora</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.cost_per_hour}
                            onChange={ (event) => {
                                let cost_per_hour = event.target.value;
                                if (cost_per_hour === '') cost_per_hour = '0';
                                if (isFloat(cost_per_hour)) {
                                    this.setState({ cost_per_hour }, this.validate);
                                }
                            }}
                        />
                    </div>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Horas</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.hours}
                            onChange={ (event) => {
                                let hours = event.target.value;
                                if (hours === '') hours = '0';
                                if (isFloat(hours)) {
                                    this.setState({ hours }, this.validate);
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const employeesReducer = state.employees;
    const stockReducer = state.stock;


    // Employees
    let employees = employeesReducer.get('payload') || List([]);
    if (!(employees instanceof List)) employees = List([]);
    if (employees.size > 0) {
        employees = employees.map(employee => employee.set('select', `[${employee.get('employee_code')}] ${employee.get('name')}`));
    }
    employees = employees.insert(0, Map({ _id: -1, select: 'Selecciona un empleado' }));

    // Stock
    const stockList = stockReducer.get('payload') || List([]);
    let productList = List([]);

    stockList.map(stock => {
        return productList = productList.insert(productList.size, stock.get('product'));
    });

    return {
        employees,
        productList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmployees: (query) => dispatch(getEmployees(query)),
        cleanEmployees: () => dispatch(cleanEmployees())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditWorkReportDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/EditWorkReportDialog.js